import axios from '~/util/axios'

export default {
  borrowerWebContent (code, userLoanAppGuid = null) {
    const queryParams = {
      code: code,
      user_loan_app_guid: userLoanAppGuid
    }
    return axios.get('/api/v1/content/borrower_web_content', { params: queryParams })
  }
}
